import { Linkedin } from "lucide-react";
import { useTradeMode, getActiveTrades, getPrimaryTrade } from "@/config/trade";

const company = [
  { name: "About", path: "/about-us" },
  { name: "Contact", path: "/contact-us" },
  { name: "Blog", path: "/blog" },
  
];

export const Footer = () => {
  useTradeMode(); // re-render when admin toggles
  const primary = getPrimaryTrade();
  const trades = getActiveTrades();

  // In single-trade mode: list that trade's sub-services.
  // In multi-trade mode: list each trade.
  const services = primary
    ? [
        { name: "All Services", path: "/services" },
        ...primary.services.map((s) => ({
          name: s.title,
          path: `/services/${primary.slug}`,
        })),
      ]
    : [
        { name: "All Services", path: "/services" },
        ...trades.map((t) => ({ name: t.name, path: `/services/${t.slug}` })),
      ];

  const tagline = primary
    ? `Your local ${primary.name.toLowerCase()} pros — ${primary.tagline}`
    : "Your local home service pros — HVAC, plumbing, electrical, roofing, and more.";

  const servicesHeading = primary ? `${primary.name} Services` : "Services";

  return (
    <footer className="glass-card border-t mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Brand Column */}
          <div>
            <h3 className="text-lg font-bold text-foreground mb-4">ProTradeOS</h3>
            <p className="text-sm text-gray-700 font-medium leading-relaxed">
              {tagline}
            </p>
          </div>

          {/* Services Column */}
          <div>
            <h3 className="text-lg font-bold text-foreground mb-4">{servicesHeading}</h3>
            <ul className="space-y-2">
              {services.map((item) => (
                <li key={item.name}>
                  <a href={item.path} className="nav-link text-sm">
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Column */}
          <div>
            <h3 className="text-lg font-bold text-foreground mb-4">Company</h3>
            <ul className="space-y-2">
              {company.map((item) => (
                <li key={item.name}>
                  <a href={item.path} className="nav-link text-sm">
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal Column */}
          <div>
            <h3 className="text-lg font-bold text-foreground mb-4">Legal</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="/terms-of-service" className="nav-link">Terms of Service</a>
              </li>
              <li>
                <a href="/privacy-policy" className="nav-link">Privacy Policy</a>
              </li>
              <li>
                <a href="/refund-policy" className="nav-link">Refund Policy</a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="text-sm text-gray-700 font-medium">
            © {new Date().getFullYear()} ProTradeOS. All rights reserved.
          </div>

          <div className="flex items-center gap-4">
            <a
              href="#"
              className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center hover:bg-primary/20 transition-colors"
              aria-label="LinkedIn"
            >
              <Linkedin className="h-5 w-5 text-primary" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
